var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { YiFeatureResponse } from "../models/yiFeatureResponse";
import { YiSessionResponse } from "../models/yiSessionResponse";
export var setupWKWebViewJavascriptBridge = function (callback) {
    var windowData = window;
    if (typeof windowData['WKWebViewJavascriptBridge'] !== 'undefined') {
        return callback(windowData['WKWebViewJavascriptBridge']);
    }
    if (typeof windowData['WKWVJBCallbacks'] !== 'undefined') {
        return windowData['WKWVJBCallbacks'].push(callback);
    }
    if (typeof windowData['WKWVJBCallbacks'] !== 'undefined') {
        windowData['WKWVJBCallbacks'] = [callback];
    }
    if (typeof windowData['webkit'] !== 'undefined') {
        windowData['webkit'].messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
    }
};
export var getErrorMessage = function (error) {
    if (error instanceof Error)
        return error.message;
    return String(error);
};
export var getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    }
    return '';
};
export var getYiIdMobileWebview = function () {
    try {
        if (typeof mobileYi !== 'undefined') {
            return mobileYi.getMobileYi();
        }
        console.log("Could not find mobileYi object");
        return '';
    }
    catch (error) {
        console.error("Error during getYiIdMobileWebview ".concat(getErrorMessage(error)));
        return '';
    }
};
export var getYiId = function (baseUrl, forceRefresh, retryCount) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    if (retryCount === void 0) { retryCount = 3; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, jsonData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 6]);
                    if (window.location.hostname.includes('zipmoney.com.au')) {
                        return [2, {
                                yi: getCookie('yi-cookie')
                            }];
                    }
                    return [4, fetch("".concat(baseUrl, "/yi?").concat(Date.now()), {
                            method: 'GET',
                            credentials: 'include',
                            headers: __assign({ 'content-type': 'application/json;charset=UTF-8' }, (forceRefresh && { 'force-refresh': 'true' }))
                        })];
                case 1:
                    response = _a.sent();
                    if (response.status > 499) {
                        throw new Error("Remote server error at ".concat(baseUrl, "/yi"));
                    }
                    return [4, response.json()];
                case 2:
                    jsonData = (_a.sent());
                    return [2, jsonData];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error during getYiId", error_1);
                    if (!(retryCount > 1)) return [3, 5];
                    return [4, getYiId(baseUrl, forceRefresh, retryCount - 1)];
                case 4: return [2, _a.sent()];
                case 5: return [2, new YiSessionResponse()];
                case 6: return [2];
            }
        });
    });
};
export var initLogin = function (baseUrl, yi, uu, retryCount) {
    if (retryCount === void 0) { retryCount = 3; }
    return __awaiter(void 0, void 0, void 0, function () {
        var data, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 5]);
                    if (!uu) {
                        return [2, false];
                    }
                    data = {
                        yi: yi,
                        uu: uu,
                    };
                    return [4, fetch("".concat(baseUrl, "/il"), {
                            method: 'POST',
                            credentials: 'include',
                            headers: {
                                'content-type': 'application/json;charset=UTF-8',
                            },
                            body: JSON.stringify(data)
                        })];
                case 1:
                    response = _a.sent();
                    if (response.status > 499) {
                        throw new Error("Remote server error at ".concat(baseUrl, "/il"));
                    }
                    return [2, true];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error during initLogin", error_2);
                    if (!(retryCount > 1)) return [3, 4];
                    return [4, initLogin(baseUrl, yi, uu, retryCount - 1)];
                case 3: return [2, _a.sent()];
                case 4: return [2, false];
                case 5: return [2];
            }
        });
    });
};
export var isRenderingForMobileApp = function () {
    var windowData = window;
    return (windowData['isNativeApp'] && windowData['isNativeApp'] === 'true') || /zip\s?.*?\/[\d|\.]+/gim.test(navigator.userAgent);
};
export var isAndroidWebView = function () {
    return isRenderingForMobileApp() && /android/i.test(navigator.userAgent);
};
export var isiOSWebView = function () {
    return isRenderingForMobileApp() && !/android/i.test(navigator.userAgent);
};
export var setContextiOSWebView = function (contextName) {
    console.log("Page Render Complete - Page Event: ".concat(contextName));
    if (typeof WKWebViewJavascriptBridge !== 'undefined') {
        WKWebViewJavascriptBridge.callHandler("callback", {
            event: 'setContextName',
            params: { 'yi_context': contextName },
            link: '/'
        });
    }
};
export var setContextAndroidWebView = function (contextName) {
    console.log("Page Render Complete - Page Event: ".concat(contextName));
    if (typeof mobileYi !== 'undefined') {
        mobileYi.setContext(contextName);
    }
};
export var setContext = function (contextName) {
    try {
        var windowData = window;
        if (windowData['cdApi'] === undefined) {
            console.log("Script not load yet - please ensure loadscript function executed.");
            return;
        }
        windowData['cdApi'].changeContext(contextName);
    }
    catch (error) {
        console.error("could not set context due to: ".concat(getErrorMessage(error)));
    }
};
export var setCustomerSessionId = function (sessionId) {
    try {
        var windowData = window;
        if (windowData['cdApi'] === undefined) {
            console.log("Script not load yet - please ensure loadscript function executed.");
            return;
        }
        windowData['cdApi'].setCustomerSessionId(sessionId);
    }
    catch (error) {
        console.error("could not set customer id due to: ".concat(getErrorMessage(error)));
    }
};
export var startNewSession = function () {
    try {
        var windowData = window;
        if (windowData['cdApi'] === undefined) {
            console.log("Script not load yet - please ensure loadscript function executed.");
            return;
        }
        windowData['cdApi'].startNewSession();
    }
    catch (error) {
        console.error("could not start new session due to: ".concat(getErrorMessage(error)));
    }
};
export var flushClient = function () {
    try {
        var windowData = window;
        if (windowData['cdApi'] === undefined) {
            console.log("Script not load yet - please ensure loadscript function executed.");
            return;
        }
        windowData['cdApi'].client.flush();
    }
    catch (error) {
        console.error("could not flush client due to: ".concat(getErrorMessage(error)));
    }
};
export var getFeaures = function (baseUrl, name, retryCount) {
    if (retryCount === void 0) { retryCount = 3; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, jsonData, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 6]);
                    return [4, fetch("".concat(baseUrl, "/fe/").concat(name), {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                                'content-type': 'application/json;charset=UTF-8',
                            }
                        })];
                case 1:
                    response = _a.sent();
                    if (response.status > 299) {
                        throw new Error("Remote server error at ".concat(baseUrl, "/feature"));
                    }
                    return [4, response.json()];
                case 2:
                    jsonData = (_a.sent());
                    return [2, jsonData];
                case 3:
                    error_3 = _a.sent();
                    console.error("Error during getFeaures", error_3);
                    if (!(retryCount > 1)) return [3, 5];
                    return [4, getFeaures(baseUrl, name, retryCount - 1)];
                case 4: return [2, _a.sent()];
                case 5: return [2, new YiFeatureResponse()];
                case 6: return [2];
            }
        });
    });
};
